import styled from 'styled-components';
import Logo from '../images/Logo';
import React, { PropsWithChildren } from 'react';

const BrandingContainer = styled.div`
    padding-top: 10px;
    width: fit-content;
`;
const BrandingDivider = styled.div`
    float: left;
    margin-left: 15px;
    margin-right: 15px;
    background-color: #424242;
    height: 55px;
    width: 1px;

    @media (max-width: 450px) {
        height: 35px;
        margin-left: 10px;
        margin-right: 10px;
    }
`;
const BrandingHeader = styled.p`
    font: 200 28px 'RingSans', Helvetica, Arial, sans-serif;
    color: #424242;
    float: left;
    margin-top: -5px;
    margin-bottom: 0px;

    @media (max-width: 750px) {
        font: 300 24px 'RingSans', Helvetica, Arial, sans-serif;
    }

    @media (max-width: 450px) {
        font: 300 16px 'RingSans', Helvetica, Arial, sans-serif;
    }
`;
const BrandingIcon = styled.div`
    float: left;
    left: 20px;
    top: 10px;
    width: 90px;

    @media (max-width: 750px) {
        width: 75px;
    }

    @media (max-width: 450px) {
        width: 60px;
    }
`;
const BrandingSubheader = styled.span`
    font: 300 18px 'RingSans', Helvetica, Arial, sans-serif;
    color: #1998d5;
    float: left;

    @media (max-width: 750px) {
        font: 300 16px 'RingSans', Helvetica, Arial, sans-serif;
    }

    @media (max-width: 450px) {
        font: 300 14px 'RingSans', Helvetica, Arial, sans-serif;
    }
`;

type Props = PropsWithChildren<{
    header: string;
    subheader?: string;
}>;

export function Branding(props: Props) {
    const {
        header,
        subheader,
    } = props;

    return (
        <BrandingContainer>
            <BrandingIcon>
                <Logo />
            </BrandingIcon>
            <BrandingDivider />
            <BrandingHeader> {header} <br />
                <BrandingSubheader> {subheader} </BrandingSubheader>
            </BrandingHeader>
        </BrandingContainer>
    );
}